<template>
    <layout-vertical>
        <!-- <div slot="breadcrumb"></div> -->
        <template #breadcrumb>
            <app-breadcrumb />
        </template>

        <router-view />

        <template #navbar="{ toggleVerticalMenuActive }">
            <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
        </template>

        <template #footer>
            <app-footer />
        </template>
        <!-- <app-customizer
        v-if="showCustomizer"
        slot="customizer"
        /> -->
    </layout-vertical>
</template>

<script>
import AppBreadcrumb from '@/layouts/components/AppBreadcrumb.vue'
import AppFooter from '@/layouts/components/AppFooter.vue'
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'
// import { mapGetters } from 'vuex'

export default {
    components: {
    // AppCustomizer,
        AppBreadcrumb,
        AppFooter,
        LayoutVertical,
        Navbar
    },
    data () {
        return {
            // showCustomizer: $themeConfig.layout.customizer,
        }
    }
    /* computed: {
        ...mapGetters([
            'authMessage',
            'authUserResource'
        ])
    } */
}
</script>

<style>
    /* [dir=ltr] .main-menu .navbar-header {
        padding: 0.35rem 1rem 0.3rem 1rem;
    } */
    [dir] .main-menu .navbar-header .navbar-brand {
        margin-top: 1rem
    }
    [dir] .dark-layout .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a,
    [dir] .dark-layout .main-menu.menu-light .navigation > li.sidebar-group-active > a {
        background-color: #161d31
    }
</style>
